<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="ImageCell">
        <img class="img" :src="row.head">
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}
</style>